<template>
  <DataTable :columns="columnList" defaultColumnOrderDir="DESC" :defaultColumnOrderIndex="7" :url="dataURL" :filterOptions="filterOptions" :displayTools="true" :hasDateRangeFilter="true"  :displayExportTools="true" exportTitle="Payment Receiveds">
    <template v-slot:title>
      <slot name="title" />
    </template>
    <template v-slot:tools>
      <slot name="tools" />
    </template>
    <template v-slot:row="row">
      <tr :key="row.data.id">
        <td class="table-data-nav-link">
          <LinkPaymentReceived :id="row.data.id" :name="row.data.sequenceNumber" :newTab="false" />
        </td>
        <td>
          <LabelBadge :labelClass="`label-payment-type-${row.data.paymentType}`">{{row.data.paymentType | formatLookupName(PaymentTypeLookup)}}</LabelBadge>
        </td>
        <td>
          <LabelBadge :labelClass="`label-payment-status-${row.data.status}`">{{row.data.status | formatLookupName(PaymentStatusTypeLookup)}}</LabelBadge>
        </td>
        <td>
          {{row.data.reference | formatHyphenEmptyValue}}
        </td>
        <td>
          <LinkContact :id="row.data.contactId" :name="row.data.contactName" />
        </td>
        <td>{{row.data.datePayment | formatDate}}</td>
        <td>
          <LinkUser :id="row.data.userId" :name="row.data.userName" />
        </td>
        <td>{{row.data.createdAt | formatDate}}</td>
        <td>
          {{row.data.amount | formatCurrency}}
        </td>
      </tr>
    </template>
    <template v-slot:summary="summary">
      <tr key="summary">
        <td>Totals</td>
        <td colspan="7"> </td>
        <td>{{summary.data.totalAmount | formatCurrency}}</td>
      </tr>
    </template>
  </DataTable>
</template>

<script>
import Utils from '@/utils/utils'

import { PaymentStatusTypes, PaymentStatusTypeLookup, PaymentTypes, PaymentTypeLookup } from '@/store/types'

export default {
  name: 'PaymentReceivedDataTable',
  props: {
    openNewTab: {
      type: Boolean,
      default: false
    },
    filterContactId: Number,
    filterType: String
  },
  created() {
    this.PaymentStatusTypeLookup = PaymentStatusTypeLookup
    this.PaymentTypeLookup = PaymentTypeLookup
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
        filter: {}
      }
      if(this.filterContactId)
        params.filter.contactId = this.filterContactId

      return '/accounts/paymentreceiveds?' + $.param(params)
    },
  },
  data() {
    return {
      filterOptions: [
        {
          field: 'status',
          name: 'Status',
          options: [
            { name: Utils.getLookupName(PaymentStatusTypeLookup, PaymentStatusTypes.authorised), value: PaymentStatusTypes.authorised, class: 'label-payment-status-authorised' },
            { name: Utils.getLookupName(PaymentStatusTypeLookup, PaymentStatusTypes.cancelled), value: PaymentStatusTypes.cancelled, class: 'label-payment-status-cancelled' },
          ]
        },
        {
          field: 'paymentType',
          name: 'Payment Type',
          options: [
            { name: Utils.getLookupName(PaymentTypeLookup, PaymentTypes.cash), value: PaymentTypes.cash, class: 'label-payment-type-cash' },
            { name: Utils.getLookupName(PaymentTypeLookup, PaymentTypes.creditCard), value: PaymentTypes.creditCard, class: 'label-payment-type-creditCard' },
            { name: Utils.getLookupName(PaymentTypeLookup, PaymentTypes.EFTPOS), value: PaymentTypes.EFTPOS, class: 'label-payment-type-EFTPOS' },
            { name: Utils.getLookupName(PaymentTypeLookup, PaymentTypes.cheque), value: PaymentTypes.cheque, class: 'label-payment-type-cheque' },
            { name: Utils.getLookupName(PaymentTypeLookup, PaymentTypes.external), value: PaymentTypes.external, class: 'label-payment-type-external' },
          ]
        }
      ],
      columnList: [
        { title: "Payment", data: "sequenceNumber" },
        { title: "Payment Type", data: "paymentType" },
        { title: "Status", data: "status" },
        { title: "Reference", data: "reference" },
        { title: "Contact", data: "contact.name" },
        { title: "Payment Date", data: "datePayment", dateFilter: true, type: 'date' },
        { title: "Received By", data: "user.name" },
        { title: "Received On", data: "createdAt", type: 'date' },
        { title: "Amount", data: "amount", type: 'currency', totalField: 'totalAmount' }
      ]
    }
  },
  methods: {
  }
};
</script>
